import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { VehicleCrewRowComponent } from '@/new-transport/_shared/vehicles-sidenav/vehicles-table/vehicle-crew-row/vehicle-crew-row.component';
import { VehicleTransport } from '@/new-transport/_models/transport.model';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
	selector: 'app-vehicles-table',
	standalone: true,
	imports: [FormsModule, MatButtonModule, MatTableModule, CommonModule, VehicleCrewRowComponent, MatTooltipModule],
	templateUrl: './vehicles-table.component.html',
	styleUrl: './vehicles-table.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehiclesTableComponent {
	readonly SHOW_ROUTE_FOR_THIS_VEHICLE_MESSAGE = 'Pokaż trasę dla tego pojazdu';
	readonly HIDE_ROUTE_FOR_THIS_VEHICLE_MESSAGE = 'Ukryj trasę dla tego pojazdu';

	readonly vehicles = input.required<VehicleTransport[]>();

	readonly tableColumns = ['vehicleName', 'vehicleCapacity', 'vehicleFreeSeats', 'vehicleCrew', 'vehicleActions'];

	vehicleUnselected = output<VehicleTransport>();
	vehicleVisibilityToggled = output<VehicleTransport>();
	vehicleCrewChanged = output<{ vehicle: VehicleTransport; crew: number }>();
	vehicleUsed = output<VehicleTransport>();

	calculateFreeSeats(crew: number, vehicle: VehicleTransport): void {
		this.vehicleCrewChanged.emit({ vehicle, crew });
	}

	unselectVehicle(vehicle: VehicleTransport): void {
		this.vehicleUnselected.emit(vehicle);
	}

	toggleVehicleVisibility(vehicle: VehicleTransport): void {
		this.vehicleVisibilityToggled.emit(vehicle);
	}

	useVehicle(vehicle: VehicleTransport): void {
		this.vehicleUsed.emit(vehicle);
	}
}
